<template>
  <div class="questionNum">
    <div class="body-footer">
      <div
        @click="goIndex(i)"
        class="body-footer-item"
        :class="i === index ? 'active': ''"
        v-for="(item,i) in question_list "
        :key="i"
      >
        {{i+1}}
        <template v-if="typeof item.right === 'boolean'">
          <img class="right" v-if="item.right" src="../assets/imgs/question/isright.png">
          <img class="wrong" v-if="!item.right" src="../assets/imgs/question/iswrong.png">
        </template>
        <img class="index" v-if="index==i" src="../assets/imgs/question/isindex.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'questionNum',
  props: {
    num: {
      type: Number,
      default: 0
    },
    question_list: {
      type: Array
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  mounted() {
    this.check()
  },
  methods: {
    check() {
      console.log(123)
    },
    goIndex(index) {
      this.$emit('goIndex', index)
    }
  }
}
</script>
<style scoped lang="scss">
.questionNum {
  padding: 0;
  margin: 0;
  width: 100%;
  position: relative;
  padding: halvePx(20);
  .body-footer {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-items: left;
    flex-wrap: wrap;
    .body-footer-item {
      width: halvePx(60);
      height: halvePx(60);
      background: #f4e5c2;
      border: halvePx(4) solid #fff;
      border-radius: 50%;
      margin: halvePx(10) halvePx(9);
      font-size: halvePx(28);
      line-height: halvePx(52);
      text-align: center;
      color: #a08c5e;
      position: relative;

      &.active {
        background: rgba(253, 232, 140, 1);
      }

      .right,
      .wrong {
        width: halvePx(34);
        height: halvePx(34);
        position: absolute;
        bottom: halvePx(-10);
        right: halvePx(-10);
      }

      .index {
        width: halvePx(21);
        height: halvePx(19);
        position: absolute;
        left: halvePx(16);
        top: halvePx(-10);
      }
    }
  }
}
</style>
